import { render, staticRenderFns } from "./MyBreadcrumb.vue?vue&type=template&id=4fd3a4fc&scoped=true"
import script from "./MyBreadcrumb.vue?vue&type=script&lang=js"
export * from "./MyBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./MyBreadcrumb.vue?vue&type=style&index=0&id=4fd3a4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd3a4fc",
  null
  
)

export default component.exports